import React, { useEffect } from 'react';
import useTransitionControl from 'common/hooks/useTransitionControl';
import * as PropTypes from 'prop-types';
import { BackDrop, Modal } from './elements';

const xPosition = {
  entering: -999,
  entered: 0,
};
const opacity = {
  entering: 0,
  entered: 0.8,
};

type Mod002Props = {
  id?: string;
  children: React.ReactNode;
  className?: string;
  show: boolean;
  modalRef?: () => void;
  onHide: () => void;
};

export default function Mod002({
  id,
  children,
  className,
  show,
  modalRef,
  onHide,
}: Mod002Props): React.ReactElement {
  if (!show) {
    return null;
  }

  const [state, enter] = useTransitionControl(0);

  useEffect(() => {
    enter();
  }, []);

  return (
    <BackDrop onClick={onHide} ref={modalRef} opacity={opacity[state]}>
      <Modal
        xPosition={xPosition[state]}
        className={className}
        id={id}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        {children}
      </Modal>
    </BackDrop>
  );
}

Mod002.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  modalRef: PropTypes.func,
  onHide: PropTypes.func,
  show: PropTypes.bool,
};
